import styled from 'styled-components';

export const ModuleContainer = styled.div`
  margin: inherit;

  body:has([id='page-not-found-fse']) & {
    margin: auto;
  }
`;
